import { ProcessStartEvent } from '@mwe/features/wizard';
import { UmmeldungStoreType } from './models';
import { Ummeldung } from '../../../generated/model/ummeldung.model';
import { ROUTE_UMMELDUNG_PRODUCT } from '../../app.constants';

export class UmmeldungWizardStateService {
  public closeWizardAndClearStore(event: ProcessStartEvent, store: UmmeldungStoreType): void {
    event.controller.close('closed');
    store.clearStore();
  }

  public resumeWizard(event: ProcessStartEvent, store: UmmeldungStoreType, resumeId: string): void {
    store.getUmmeldungById(resumeId).subscribe({
      next: (ummeldung: Ummeldung) => {
        if (!ummeldung.aktuellerProzessSchritt) {
          return;
        }
        const targetStep = event.controller.getStepForId(ummeldung.aktuellerProzessSchritt);
        if (targetStep && targetStep.route.path !== ROUTE_UMMELDUNG_PRODUCT) {
          event.controller.navigateToStep({ step: targetStep, skipValidation: true });
        }
      },
      error: () => {
        return this.closeWizardAndClearStore(event, store);
      },
    });
  }
}
